import { render, staticRenderFns } from "./ActualQueryComponent.vue?vue&type=template&id=5486639b&scoped=true"
import script from "./ActualQueryComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActualQueryComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ActualQueryComponent.vue?vue&type=style&index=0&id=5486639b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5486639b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5486639b')) {
      api.createRecord('5486639b', component.options)
    } else {
      api.reload('5486639b', component.options)
    }
    module.hot.accept("./ActualQueryComponent.vue?vue&type=template&id=5486639b&scoped=true", function () {
      api.rerender('5486639b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/documentSearcher/components/SearchAdvanceIA/components/SearchIaBoxQuery/components/ActualQueryComponent.vue"
export default component.exports